import { hasClass, removeClass, addClass } from 'helpers/dom'

const selectors = {
  ITEM_SELECTOR: '.js-accordion-item',
  BUTTON_SELECTOR: '.js-accordion-button',
  CONTENT_SELECTOR: '.js-accordion-content',
  HEADING_BUTTON_CLASS: '.js-accordion-button .text',
  INVISIBLE_CLASS: 'invisible',
  VIDEO_PLAYER_SELECTOR: 'video-player',
  VIDEO_SELECTOR: 'video-player video',
  VIDEO_PLAY_BUTTON_CLASS: '.accordion-product .js-video-player-thumbnail-button'
}

class AccordionList extends HTMLElement {
  constructor() {
    super()

    this.init()
  }

  close(items) {
    items.forEach((item) => {
      const content = item.querySelector(selectors.CONTENT_SELECTOR)
      const button = item.querySelector(selectors.BUTTON_SELECTOR)
      const videoPlayerEl = item.querySelector(selectors.VIDEO_PLAYER_SELECTOR)
      const videoEl = item.querySelector(selectors.VIDEO_SELECTOR)

      if (button && content) {
        content.style.maxHeight = '0px'
        button.setAttribute('aria-expanded', 'false')
        item.removeAttribute('open')
        addClass(selectors.INVISIBLE_CLASS, content)
      }

      if (videoPlayerEl && (videoPlayerEl.classList.contains('is-playing') || videoPlayerEl.hasAttribute('autoplay'))) {
        videoPlayerEl.status.play = false
        if (videoEl) videoEl.pause()
      }
    })
  }

  open(item) {
    const content = item.querySelector(selectors.CONTENT_SELECTOR)
    const button = item.querySelector(selectors.BUTTON_SELECTOR)
    const videoButton = item.querySelector(selectors.VIDEO_PLAY_BUTTON_CLASS)
    const videoPlayerEl = item.querySelector(selectors.VIDEO_PLAYER_SELECTOR)
    const videoEl = item.querySelector(selectors.VIDEO_SELECTOR)

    content.style.maxHeight = content.children[0].scrollHeight + 'px'
    button.setAttribute('aria-expanded', 'true')
    item.setAttribute('open', true)

    if (hasClass(selectors.INVISIBLE_CLASS, content)) {
      removeClass(selectors.INVISIBLE_CLASS, content)
    }

    if (videoPlayerEl && !videoPlayerEl.classList.contains('is-playing')) {
      videoPlayerEl.status.play = true
      if (videoEl) videoEl.play()
    }
  }

  toggleDescription(item, list) {
    if (item && !item.hasAttribute('open')) {
      this.close(list)
      this.open(item)
    } else {
      this.close(list)
    }
  }

  init() {
    const list = this.querySelectorAll(selectors.ITEM_SELECTOR)

    if (list.length) {
      list.forEach((item) => {
        const button = item.querySelector(selectors.BUTTON_SELECTOR)
        const textTitle = item.querySelector(selectors.HEADING_BUTTON_CLASS)

        if (textTitle) {
          textTitle.innerHTML = textTitle.innerHTML.replace(/(^\w|\s\w)(\S*)/g, (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase())
        }

        if (item.hasAttribute('open')) {
          this.open(item)
        }

        if (button) {
          const _this = this

          button.onclick = function (e) {
            if (location.pathname.includes('store-locator')) {
              e.stopPropagation()
            }
            _this.toggleDescription(item, list)
          }
        }
      })
    }
  }
}

if (!customElements.get('accordion-list')) {
  customElements.define('accordion-list', AccordionList)
}
